import { render, staticRenderFns } from "./ConfirmPrintDispatch.vue?vue&type=template&id=21c498a5&scoped=true"
import script from "./ConfirmPrintDispatch.vue?vue&type=script&lang=js"
export * from "./ConfirmPrintDispatch.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPrintDispatch.vue?vue&type=style&index=0&id=21c498a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c498a5",
  null
  
)

export default component.exports